import { useQuery } from "@tanstack/react-query";
import { retrieveWorkflowInvitations } from "@/lib/data/requests/connections/workflow-invitations";
export const workflowInvitationQueryOptions = (
  path: string,
  matterId?: string,
  enabled = true,
) => ({
  queryKey: ["v4", "workflow-invitations", path, { matterId }],
  queryFn: () => retrieveWorkflowInvitations(path, matterId),
  enabled,
  staleTime: 0,
  gcTime: 0,
});
export const useWorkflowInvitations = (
  path: string,
  matterId?: string,
  enabled = true,
) => useQuery(workflowInvitationQueryOptions(path, matterId, enabled));
